import { render, staticRenderFns } from "./DocumentsPerson.vue?vue&type=template&id=38d92fe4&scoped=true"
import script from "./DocumentsPerson.vue?vue&type=script&lang=js"
export * from "./DocumentsPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d92fe4",
  null
  
)

export default component.exports